<template>
    <div>
        <Modal
                v-model="dialInfo.modal1"
                class-name="dialog"
                :width="420"
                :closable="dialInfo.closable"
                :mask-closable="false"
                :styles="{top: '240px'}">
            <div class="dialog-main" v-if="dialInfo.type === 0">
                <div class="title">
                    <span>确认付款</span>
                    <span @click="close" class="close">
                        <i class="iconfont icon-pop-close"></i>
                    </span>
                </div>
                <div class="success">
                    <div>支付成功请点击</div>
                    <span @click="sureComPay(0)">已完成付款</span>
                </div>
                <div class="fail">
                    <div>支付失败请点击</div>
                    <span @click="sureComPay(1)">重新付款</span>
                    <!--<router-link :to="{name:'choicePay', params: {id: orderId,type: typeData}}">-->
                       <!---->
                    <!--</router-link>-->
                </div>
                <div class="msg">
                    <span>如有疑问请联系我们，客服电话<span class="color" style="color:#308697;">400-998-0137</span></span>
                </div>
            </div>
        </Modal>
        <delete-confirm ref="deleteConfirm"></delete-confirm>
    </div>
</template>
<script>
    import api from '../../../../api'
    import deleteConfirm from '../../../common/deleteConfirm.vue'

    export default {
        props: {
            dialInfo: {
                type: Object,
            },
            orderId: {
//                type: String
            },
            typeData: {
                type: String || Number
            }
        },
        data() {
            return {
                isShowTitle: false,
                VUE_APP_NEXT_BASIC_URL: process.env.VUE_APP_NEXT_BASIC_URL,
            };
        },
        components: {
            deleteConfirm
        },
        methods: {

            //检查是否付款完成
            sureComPay(info) {
                const data = {
//                    'type': this.typeData,
                    'chargeId': this.orderId
                }
                this.dialInfo.modal1 = false
                api.pay.sureComPay(data)
                    .then(res => {
                        if (res) {
                            this.$router.push({
                                path: this.VUE_APP_NEXT_BASIC_URL + '/my-order'
                            })
                        } else {
                            if (info === 0) {
                                this.$refs.deleteConfirm.open({
                                    text: '暂时还未完成付款，请继续付款？',
                                    bigButton: 1
                                });
                            }else{
                                this.$router.go(0)
                            }
                        }
                    })
            },
            close(){
               this.dialInfo.modal1 = false;
               this.$emit('closeDialog')
            }
        },
    };
</script>
<style scoped>
    .dialog-main {
        height: 400px;
    }

    .dialog-main .title {
        position: relative;
        height: 86px;
        width: 100%;
        text-align: center;
        line-height: 86px;
    }
    .dialog-main .title .close{
        position: absolute;
        right: 20px;
        top: -20px;
        font-size: 20px;
        cursor: pointer;
    }

    .dialog-main .title span {
        font-size: 20px;
        color: #353838;
    }

    .dialog-main .success,
    .dialog-main .fail {
        height: 60%;
        width: 50%;
        float: left;
        text-align: center;
        cursor: pointer;
    }

    .dialog-main .success span,
    .dialog-main .fail span {
        display: inline-block;
        width: 145px;
        height: 44px;
        text-align: center;
        line-height: 44px;
    }

    .dialog-main .success div,
    .dialog-main .fail div {
        width: 100%;
        font-size: 12px;
        color: #353838;
        text-align: center;
        margin-top: 80px;
        margin-bottom: 10px;
    }

    .dialog-main .success span {
        font-size: 14px;
        color: #6C6F70;
        background: #EBEFF0;
    }

    .dialog-main .fail span {
        background: #E14B5D;
        font-size: 14px;
        color: #FFFFFF;
    }

    .dialog-main .msg {
        width: 100%;
    }

    .dialog-main .msg span {
        font-size: 12px;
        color: #6C6F70;
    }

    .dialog-main .msg span .color {
        font-size: 12px;
        color: #00383D;
        text-decoration: underline;
    }

    .sure-dialog-main {
        height: 236px;
    }

    .sure-dialog-main .sure-title {
        font-size: 20px;
        color: #E14B5D;
        margin-top: 67px;
        float: left;
        width: 100%;
        text-align: center;
    }

    .sure-dialog-main .sure-title span {
        font-size: 16px;
        color: #E14B5D;
    }

    .sure-dialog-main .success, .sure-dialog-main .fail {
        width: 50%;
        float: left;
        margin-top: 36px;
    }

    .sure-dialog-main .success span, .sure-dialog-main .fail span {
        display: inline-block;
        width: 86px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 4px;
        cursor: pointer;
    }

    .sure-dialog-main .success span {
        color: #555555;
        margin-left: 30px;
    }

    .sure-dialog-main .fail span {
        background: #308697;
        color: #fff;
        margin-right: 30px;
    }
</style>
<style>
    .ivu-modal {
        width: 360px;
    }

    .ivu-modal-close .ivu-icon-ios-close-empty {
        top: -10px;
    }
</style>
<style rel="stylesheet/scss" lang="scss">
    .sure-dialog-main {
        .success {
            >span{
                width: 86px;
                height: 44px;
                background: #F2F4F5;
                border-radius: 4px;
                border: 0 none;
                color: #6C6F70;
                font-size: 14px;
            }

        }
    }
</style>